// components/03_footer/ContactFormStyle.js
import styled from "styled-components";
import { MainInput } from "../../01_config/MainStyles";
import { colors } from "../../01_config/Colors";

export const ContactFormWrapper = styled.form`
  position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  display: ${({ contactVisible }) => (contactVisible ? "flex" : "none")};
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  width: 500px;
      max-width: 70vw;
  text-align: left;
  padding: 20px;
  color: white;
  background-color: ${colors.mainDark};
  border-radius: 8px;
  z-index: 200;
`;

export const InputWrapper = styled.div`
  width: 100%;
  line-height: 1.4;
`;

export const Label = styled.div`
  font-size: 0.9rem;
  margin-bottom: 4px;
`;

export const NameInput = styled(MainInput)`
  width: 100%;
  height: 28px;
`;

export const EmailInput = styled(NameInput)``;

export const PhoneInput = styled(NameInput)``;

export const MessageArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 6px 8px;
  border-radius: 5px;
  border: none;
  font-size: 0.9rem;
  resize: vertical;
  outline: none;

  &:focus {
    outline: 2px solid ${colors.grammar || "darkblue"};
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media (max-width: 800px) {
    width: 100%;
    align-items: center;
  }
`;

export const SendButton = styled.button`
  width: 140px;
  height: 35px;
  font-size: 1rem;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #5b4ed3;

  @media (max-width: 800px) {
    width: calc(30px + 60vw);
    height: 5vh;
  }

  &:active {
    transform: translate(2px, 2px);
  }
`;

export const CancelButton = styled(SendButton)`
  background-color: grey;
`;

export const Title = styled.div`
  font-size: 1.3rem;
  color: white;
  font-weight: 600;
  margin-bottom: 10px;
`;

export const Subtitle = styled.div`
    color: yellow;
    font-size: 1rem;
    text-align: center;
    // visibility: ${({emailSent}) => emailSent ? "visible" : "hidden"};
`
